import { render, staticRenderFns } from "./CorrespondenceLetterSummary.vue?vue&type=template&id=717f7cac&scoped=true"
import script from "./CorrespondenceLetterSummary.vue?vue&type=script&lang=js"
export * from "./CorrespondenceLetterSummary.vue?vue&type=script&lang=js"
import style0 from "./CorrespondenceLetterSummary.vue?vue&type=style&index=0&id=717f7cac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717f7cac",
  null
  
)

export default component.exports